/** Base URL of Trader.API, without a trailing slash (VITE_API_URL at build time). */
export const apiUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, '');

/** Decision D4: one currency label everywhere. */
export const currencyLabel = 'USDT';

/** Every storage key starts with this, so this app and the old one never read each other's data. */
export const storagePrefix = 'trader-next.';

/** Shown where an action needs an API feature the deployed API does not report (GET /Features): the API is older. */
export const needsCurrentApi = 'Needs the current API: deploy Trader.API.';
